import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["defaultMonthYearSelectorOpen"];
import { useEffect, useMemo, useState } from 'react';
import { DateVector } from '../utils/DateVector';
import { TimeVector24 } from '../utils/TimeVector24';
import { useFlagState, useDerivedState } from '../../../system';
export var useDatePickerState = function useDatePickerState(_ref, _ref2) {
  var reallyOpen = _ref.reallyOpen,
      internalValue = _ref.internalValue;

  var defaultMonthYearSelectorOpen = _ref2.defaultMonthYearSelectorOpen,
      restProps = _objectWithoutProperties(_ref2, _excluded);

  var _useState = useState(internalValue.clone()),
      _useState2 = _slicedToArray(_useState, 2),
      dirtyInternalValueVector = _useState2[0],
      setDirtyInternalValueVector = _useState2[1];

  useEffect(function () {
    setDirtyInternalValueVector(internalValue.clone());
  }, [internalValue]);
  var currentDateVector = useMemo(function () {
    return DateVector.createFromLocalDate();
  }, [reallyOpen]);
  var currentTimeVector = useMemo(function () {
    return TimeVector24.createFromDateVector(currentDateVector);
  }, [currentDateVector]);

  var _useState3 = useState(dirtyInternalValueVector.dateStart ? dirtyInternalValueVector.dateStart.clone() : currentDateVector.clone()),
      _useState4 = _slicedToArray(_useState3, 2),
      displayedDateVector = _useState4[0],
      setDisplayedDateVector = _useState4[1];

  var _useDerivedState = useDerivedState(function () {
    return dirtyInternalValueVector.dateStart ? TimeVector24.createFromDateVector(dirtyInternalValueVector.dateStart) : currentTimeVector;
  }, [dirtyInternalValueVector, currentTimeVector]),
      _useDerivedState2 = _slicedToArray(_useDerivedState, 2),
      timeSelectorValue = _useDerivedState2[0],
      setTimeSelectorValue = _useDerivedState2[1];

  var _useFlagState = useFlagState(defaultMonthYearSelectorOpen),
      _useFlagState2 = _slicedToArray(_useFlagState, 5),
      monthYearSelectorOpen = _useFlagState2[0],
      onMonthYearSelectorToggle = _useFlagState2[4];

  return {
    dirtyInternalValueVector: dirtyInternalValueVector,
    setDirtyInternalValueVector: setDirtyInternalValueVector,
    timeSelectorValue: timeSelectorValue,
    setTimeSelectorValue: setTimeSelectorValue,
    displayedDateVector: displayedDateVector,
    setDisplayedDateVector: setDisplayedDateVector,
    currentDateVector: currentDateVector,
    monthYearSelectorOpen: monthYearSelectorOpen,
    onMonthYearSelectorToggle: onMonthYearSelectorToggle,
    restProps: restProps
  };
};